
import colors from '../../../public/colors'


export default theme => {
    const { mode } = theme.palette
    return {
        container: {
            alignItems: 'center',
            backgroundColor: colors[mode].insightCardHover,
            boxSizing: 'border-box',
            maxWidth: '650px',
            minHeight: '481px',
            padding: '0px 0px',
            width: '100%'
        },
        footerDivider: {
            backgroundColor: theme.palette.divider || 'rgba(0, 0, 0, 0.12)',
            margin: 0
        },
        footerWrapper: {
            alignItems: 'center',
            boxSizing: 'border-box',
            display: 'flex',
            justifyContent: 'center',
            minHeight: '80px',
            padding: '0 4%',
            width: '100%',
            [theme.breakpoints.down('sm')]: {
                minHeight: '60px',
                padding: '7% 3%'
            },
            [theme.breakpoints.down('xs')]: {
                minHeight: '50px',
                padding: '0 2%'
            }
        },
        header: {
            boxSizing: 'border-box',
            display: 'grid',
            height: '56px',
            padding: '0 4%'
        },
        headerDivider: {
            backgroundColor: theme.palette.divider || 'rgba(0, 0, 0, 0.12)',
            margin: 0
        },
        title: {
            alignSelf: 'center',
            color: colors[mode].mfaActiveBackground,
            fontSize: '1.25rem',
            [theme.breakpoints.down('md')]: {
                lineHeight: '20px'
            }
        
        }
    }}